import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../home/components/Footer';
import PageCTA from '../../components/feature/PageCTA';

export default function AppWars() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-600 via-orange-600 to-amber-600 text-white pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8">
              <i className="ri-sword-line text-4xl"></i>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              App Wars: A Competition Powered by Intelligence — Not Votes
            </h1>
            <p className="text-xl md:text-2xl mb-10 text-white/90 leading-relaxed">
              Founders submit their apps, receive objective scoring, and compete based on performance — not popularity or hype.
            </p>
            <Link
              to="/pricing"
              className="inline-block bg-white text-orange-600 px-10 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              Submit Your App
            </Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              A Transparent, Data-Based Competition
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
            {/* Step 1 */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-red-600 to-orange-600 text-white rounded-full mb-6 text-3xl font-bold">
                1
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Submit Your App
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                Founders enter with a link or prototype description.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold">
                No influence, no favoritism.
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-orange-600 to-amber-600 text-white rounded-full mb-6 text-3xl font-bold">
                2
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Intelligence Evaluation
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                Your app is objectively scored using the same structured evaluation process used in our tiers.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold">
                Every app goes through the same rules and benchmarks.
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-600 to-yellow-600 text-white rounded-full mb-6 text-3xl font-bold">
                3
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Winner Showcase
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3">
                Top-performing apps receive visibility, credibility, and spotlight placement.
              </p>
              <p className="text-gray-600 leading-relaxed font-semibold">
                Your score determines your ranking — not opinions or votes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Founders Join */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-orange-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Founders Join
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { icon: 'ri-scales-3-line', text: 'Fair and objective scoring' },
              { icon: 'ri-shield-check-line', text: 'No popularity contest' },
              { icon: 'ri-close-circle-line', text: 'No voting manipulation' },
              { icon: 'ri-equalizer-line', text: 'A level playing field' },
              { icon: 'ri-brain-line', text: 'Results based on real intelligence' },
              { icon: 'ri-eye-line', text: 'Exposure for high performers' },
              { icon: 'ri-global-line', text: 'A chance to enter future global shows' }
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition-all">
                <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-orange-600 to-red-600 text-white rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <p className="text-lg text-gray-900 font-medium pt-2">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <PageCTA 
        title="Ready to Compete?"
        description="Submit your app and compete based on intelligence — not popularity."
        primaryText="Submit Your App"
        primaryLink="/pricing"
        bgGradient="from-red-600 via-orange-600 to-amber-600"
      />

      <Footer />
    </div>
  );
}
